export default function getSum(arg: Record<string, number>) {
  return Object.values(arg).reduce((a, b) => a + b, 0);
}
